import React from "react";
import { Chip, Grid, Typography } from "@mui/material";
import tick from "assets/images/Service icon.svg";

export default function SettingOurService(props) {
  return (
    <div>
      <Grid className="margin10 borderStyle paddingInline40Block20">
        <Typography className="colorBlue font18">Services</Typography>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className=" margin10"
          rowSpacing={2}
        >
          {props?.chooseYourServiceData?.map(
            (service, index) =>
              service?.status === "Active" && (
                <Grid
                  item
                  container
                  spacing={2}
                  lg={3.5}
                  md={5}
                  sm={12}
                  xs={12}
                  direction="row"
                  alignItems="center"
                  justifyItems="center"
                  className="borderStyle margin10"
                  key={service.id}
                >
                  <Grid item>
                    <img src={tick} alt="wallet" />
                  </Grid>
                  <Grid item className="cardAlign" md={8} sm={9}>
                    <p className="marginBlock10 font28 colorBlack fontMedium">
                      {service?.name}
                    </p>
                    <p className="marginBlock10 font20 colorBlack ">
                      {" "}
                      {service?.tripCount ? service?.tripCount : "0"}
                    </p>
                  </Grid>
                </Grid>
              )
          )}
        </Grid>
        {/* TODO: we can use serviceregion in future */}
        {/* <Grid className="marginTop25">
          <div className="borderFilled"></div>
          <Typography className="colorBlue font18 marginTop25">
            {" "}
            Serviceable Areas
          </Typography>
          <Grid container className="margin10" direction="row">
            {props?.serviceRegion?.map((ele, id) => (
              <>
                <Chip
                  label={ele.name}
                  variant="outlined"
                  className="margin10 colorGrey font16 forntNormal"
                />
              </>
            ))}
          </Grid>
        </Grid> */}
      </Grid>
    </div>
  );
}
